import { IonButton, IonInput, IonLoading } from '@ionic/react';
import { Redirect, useHistory } from 'react-router-dom';
import { FormEvent, useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase';
import { useAuth } from '../../auth';
import { clearAuthAttempts, getAuthRetryAfter, recordAuthAttempt } from '../../utils/AuthRateLimit';
import '../home/AuthForms.css';

const LOGIN_WINDOW = 60_000;

const LoginModal: React.FC = () => {
  const { loggedIn } = useAuth();
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [website, setWebsite] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleLogin = async (event: FormEvent) => {
    event.preventDefault();
    if (website) return;
    const retryAfter = getAuthRetryAfter('login', 5, LOGIN_WINDOW);
    if (retryAfter) {
      setErrorMessage(`Too many attempts. Please wait ${retryAfter} seconds and try again.`);
      return;
    }

    try {
      setLoading(true);
      setErrorMessage('');
      recordAuthAttempt('login', LOGIN_WINDOW);
      await signInWithEmailAndPassword(auth, email.trim(), password);
      clearAuthAttempts('login');
    } catch {
      setErrorMessage('Login was not successful. Check your details or reset your password.');
    } finally {
      setLoading(false);
    }
  };

  if (loggedIn) return <Redirect to="/my/training" />;

  return (
    <form className="auth-form" onSubmit={handleLogin}>
      <div className="auth-form__intro"><span>Welcome back</span><h2>Continue your progress</h2><p>Your training data remains on this device.</p></div>
      <input className="auth-honeypot" tabIndex={-1} autoComplete="off" aria-hidden="true" value={website} onChange={event => setWebsite(event.target.value)} />
      <IonInput className="auth-input" label="Email" labelPlacement="stacked" fill="outline" type="email" autocomplete="email" value={email} onIonInput={event => setEmail(event.detail.value || '')} required />
      <IonInput className="auth-input" label="Password" labelPlacement="stacked" fill="outline" type="password" autocomplete="current-password" value={password} onIonInput={event => setPassword(event.detail.value || '')} required />
      <button type="button" className="auth-text-action" onClick={() => history.push('/pw-recovery')}>Forgot password?</button>
      {errorMessage && <p className="auth-error" role="alert">{errorMessage}</p>}
      <IonButton type="submit" expand="block" shape="round" disabled={loading || !email.trim() || !password}>Log in</IonButton>
      <IonLoading isOpen={loading} message="Signing you in…" />
    </form>
  );
};

export default LoginModal;
